import {
  getSoftwareNameList,
  saveSoftwareNameAPI,
  deleteSoftwareNameAPI,
  getSoftwareNameCombo
} from '../../../services/Masters/MatersService';

export const fetchSoftwareNames = async (statusGUID) => {
  try {
    const response = await getSoftwareNameList(statusGUID);

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching software names',
        variant: 'error'
      });
      console.log('Error fetching software names:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching software names',
      variant: 'error'
    });
    console.log('Error fetching software names:', err);
    return [];
  }
};

export const fetchSoftwareNamesCombo = async () => {
  try {
    const response = await getSoftwareNameCombo();

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching software names',
        variant: 'error'
      });
      console.log('Error fetching software names:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching software names',
      variant: 'error'
    });
    console.log('Error fetching software names:', err);
    return [];
  }
};

export const saveSoftwareName = async (payload, customSuccessMsg, customErrorMsg) => {
  try {
    const response = await saveSoftwareNameAPI(payload);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to save software name');
      window.showSnackbar({
        message: customErrorMsg || `Failed to save software name`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `Software name saved successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage =
      err?.message || (typeof err === 'string' ? err : 'Failed to save software name');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to save software name:', err);
    return { success: false, message: errorMessage };
  }
};

export const deleteSoftwareName = async (
  softwareNameGUID = '',
  customSuccessMsg,
  customErrorMsg
) => {
  try {
    const response = await deleteSoftwareNameAPI(softwareNameGUID);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to delete software name');
      window.showSnackbar({
        message: customErrorMsg || `Failed to delete software name`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `Software name deleted successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage =
      err?.message || (typeof err === 'string' ? err : 'Failed to delete software name');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to delete software name:', err);
    return { success: false, message: errorMessage };
  }
};
